export default __webpack_public_path__ + "static/media/640_business05-en-mobile.961102d9.png";